angular.module('bizmetryApp').controller('ViewRecordDetailsDialogController', 
    function($scope, $timeout, $mdDialog, $mdToast, ResourceService, dialogService,
             profile, environment, resource, resourceType, pkAttribute, pkColumnName, pkValue,
             resourceAttributes) {

    var vm = this;

    vm.profile            = profile;
    vm.environment        = environment;
    vm.resource           = resource;
    vm.resourceType       = resourceType;
    vm.pkAttribute        = pkAttribute;
    vm.pkColumnName       = pkColumnName;
    vm.pkValue            = pkValue;
    vm.resourceAttributes = resourceAttributes;

    vm.loading    = true;
    vm.error      = null;
    vm.errorTitle = null;
    vm.recordData = null;
    // The stored copy: PK it belongs to, when and by whom it was captured.
    vm.recordInfo = null;
    // The PK was edited (and not saved) after the record was captured.
    vm.pkChanged  = false;

    // ===== STATS =====
    vm.stats = { total: 0, pk: 0, sensitive: 0 };

    // ===== CLOSE =====
    vm.close = function() {
        $mdDialog.hide();
    };

    // ===== TOGGLE SENSITIVE VISIBILITY =====
    vm.toggleSensitiveVisibility = function(field) {
        if (field.isSensitive) {
            field.visible = !field.visible;
        }
    };

    // ===== JSON VALUES → biz-json-viewer =====
    vm.jsonViewer = { open: false, json: null, title: null };

    // JSON when the attribute is declared JSON, or the value arrived as an object/array
    vm.isJsonField = function(field) {
        if (field.value === null || field.value === undefined || field.value === '') { return false; }
        return String(field.type).toUpperCase() === 'JSON' || typeof field.value === 'object';
    };

    vm.jsonPreview = function(value) {
        var text = typeof value === 'string' ? value : JSON.stringify(value);
        return text.length > 48 ? text.substring(0, 47) + '…' : text;
    };

    vm.openJsonViewer = function(field, $event) {
        if ($event) { $event.stopPropagation(); }
        vm.jsonViewer = { open: true, json: field.value, title: vm.resource.resourceName + ' · ' + field.logicalName };
    };

    vm.closeJsonViewer = function() {
        vm.jsonViewer.open = false;
    };

    // Escape closes only the viewer, not the dialog (md-dialog listens for Escape too)
    function onKeydown(event) {
        if (event.key === 'Escape' && vm.jsonViewer.open) {
            event.stopPropagation();
            $scope.$apply(vm.closeJsonViewer);
        }
    }
    document.addEventListener('keydown', onKeydown, true);
    $scope.$on('$destroy', function() {
        document.removeEventListener('keydown', onKeydown, true);
    });

    // ===== COPY TO CLIPBOARD =====
    vm.copyToClipboard = function(field, $event) {
        if ($event) { $event.stopPropagation(); }
        if (field.value === null || field.value === undefined || field.value === '') { return; }

        var text = typeof field.value === 'object' ? JSON.stringify(field.value, null, 2) : String(field.value);

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text)
                .then(function() { showCopiedFeedback(field); })
                .catch(function() { fallbackCopy(text, field); });
        } else {
            fallbackCopy(text, field);
        }
    };

    function fallbackCopy(text, field) {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity  = '0';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        try {
            document.execCommand('copy');
            showCopiedFeedback(field);
        } catch (e) {
            console.warn('Copy failed', e);
        }
        document.body.removeChild(ta);
    }

    function showCopiedFeedback(field) {
        field.copied = true;
        $timeout(function() {
            field.copied = false;
        }, 1800);
    }

    // ===== LOAD RECORD DATA =====
    // The record stored for this environment at import (Resource.sourceRecords), read from
    // resource-ms: no agent call, works with the datasource offline.
    vm.loadRecordData = function() {
        vm.loading = true;
        vm.error   = null;

        ResourceService.getSourceRecord(vm.profile.id, vm.resource.id, vm.environment.id)
            .then(function(response) {
                var record = (response && response.data) || {};
                vm.recordInfo = {
                    externalId: record.externalId,
                    importedTs: record.importedTs,
                    importedBy: record.importedBy
                };
                vm.pkChanged  = record.externalId != null && vm.pkValue != null
                    && String(record.externalId) !== String(vm.pkValue);
                vm.recordData = buildFields(record.data || {});

                vm.stats.total     = vm.recordData.length;
                vm.stats.pk        = vm.recordData.filter(function(f) { return f.isPrimaryKey; }).length;
                vm.stats.sensitive = vm.recordData.filter(function(f) { return f.isSensitive; }).length;
                vm.loading = false;
            })
            .catch(function(error) {
                vm.loading = false;
                if (error && error.status === 404) {
                    vm.errorTitle = 'No stored record';
                    vm.error = 'This resource has no record stored for ' + vm.environment.name + '. It is captured when '
                        + 'the resource is imported from the datasource (resources created by hand, or imported '
                        + 'before records were stored, have none) — re-import it to store one.';
                    return;
                }
                var errorMessage = 'Failed to load the stored record.';
                if (error && error.data) {
                    if (typeof error.data === 'string') {
                        errorMessage = error.data;
                    } else if (error.data.error && error.data.message) {
                        errorMessage = dialogService.formatErrorMessage(error.data);
                    } else if (error.data.message) {
                        errorMessage = error.data.message;
                    }
                }
                vm.errorTitle = 'Could not load record';
                vm.error = errorMessage;
                $mdToast.show($mdToast.simple().textContent(errorMessage).position('top right').hideDelay(5000));
            });
    };

    // One field per resource attribute mapped to a column, in template order. Sensitive attributes
    // start hidden (visible: false) and are revealed only with their toggle button.
    function buildFields(row) {
        var rowKeys = {};
        Object.keys(row).forEach(function(k) { rowKeys[k.toLowerCase()] = k; });
        var pkLower = (vm.pkColumnName || '').toLowerCase();

        return vm.resourceAttributes
            .filter(function(attr) { return attr.column_metadata_name && attr.column_metadata_name.trim() !== ''; })
            .map(function(attr) {
                var column = attr.column_metadata_name;
                var key    = rowKeys[column.toLowerCase()];
                var value  = key !== undefined ? row[key] : null;
                return {
                    physicalName: column,
                    logicalName:  attr.name || column,
                    type:         attr.scalar_attribute_type || 'STRING',
                    value:        value !== undefined ? value : null,
                    isPrimaryKey: !!attr.isPrimaryKey || column.toLowerCase() === pkLower,
                    isSensitive:  attr.isSensitive === true || attr.isSensitive === 1,
                    visible:      false,
                    copied:       false
                };
            });
    }

    console.log('🚀 ViewRecordDetailsDialogController initialized:', {
        environment:     vm.environment.name,
        resource:        vm.resource.resourceName,
        resourceType:    vm.resourceType.name,
        pkAttribute:     vm.pkAttribute.name,
        pkColumnName:    vm.pkColumnName,
        pkValue:         vm.pkValue,
        attributesCount: vm.resourceAttributes.length
    });

    vm.loadRecordData();
});